import React from 'react';
import './App.css';
import {  Route, Routes } from 'react-router-dom';
import Login from './components/Login/index'
import OM from './components';

function App() {

  function setToken(userToken) {
    localStorage.setItem('token', `Bearer ${userToken.token}`);
    localStorage.setItem('OM',userToken.OM_code);
  }
  return (
    <div className="App">
      <Routes>
          <Route path="/omPortal/login" element={<Login setToken={setToken}/>}/>
          <Route path="/omPortal/app/*" element={<OM/>} />
      </Routes>
    </div>
  );
}

export default App;